import React from "react";
import "./SongSubmission.css"
import SubmissionPost from "../assets/SubmissionPost.jpg"
import GlaciaLogo from "../assets/GLACIA LOGO.jpg"
import TitleLogo from "../assets/TitleLogo.png"
import CNSubmission from "./CNSubmission";
import ENSubmission from "./ENSubmission";
import JPSubmission from "./JPSubmission";
import KRSubmission from "./KRSubmission";

//标题
class Title extends React.Component{
    render(){
        return(
            <div className='Title'>
               <img className='TitleLogo' src={TitleLogo} alt=""/>
               <img className="GlaciaLogo" src={GlaciaLogo} alt=""/>
            </div>
            
        )
    }
  }

//活动列表组件
class EventContainer extends React.Component{
  constructor(){
    super();
    this.state={
      render:'',
      activebtn:'button0',
      lastactive:'button0'
    }
  }

  ShowLanguage(name,active){
    const lastactive = this.state.activebtn
    this.setState({render:name,activebtn:active,lastactive:lastactive})
  }
  renderComponent=()=>{
    let active = null
    let lastactive = null
    switch(this.state.render){
      case '中文':
        active = document.getElementById(this.state.activebtn)
        lastactive = document.getElementById(this.state.lastactive)
        active.className = "Btnactive"
        lastactive.className = "Btninactive"
        return <CNSubmission/>
      case 'English': 
        active = document.getElementById(this.state.activebtn)
        lastactive = document.getElementById(this.state.lastactive)
        active.className = "Btnactive"
        lastactive.className = "Btninactive"
        return <ENSubmission/>
      case '日本语':
        active = document.getElementById(this.state.activebtn)
        lastactive = document.getElementById(this.state.lastactive)
        active.className = "Btnactive"
        lastactive.className = "Btninactive"
        return <JPSubmission/>
        case '한국어':
          active = document.getElementById(this.state.activebtn)
          lastactive = document.getElementById(this.state.lastactive)
          active.className = "Btnactive"
          lastactive.className = "Btninactive"
          return <KRSubmission/>
      default: 
      return <CNSubmission/>
    }
  }
  render(){
    const LangList = ["中文","English","日本语","한국어"]
    const offsetWidth = document.querySelector("body").offsetWidth
    return(
      <div className="EventContainer">
        <div style={{textIndent:"0"}}>
        <img src={SubmissionPost} className="SubmissionPost" alt=""/>
        </div>
        <div className="LanguageList" id="LanguageList" style={offsetWidth<1080?{width:"100%"}:{width:"60%"}}>
        {
        LangList.map(item=><button className={LangList.indexOf(item)===0?"Btnactive":"Btninactive"} id={"button"+LangList.indexOf(item)} style={offsetWidth<1080?offsetWidth<420?{fontSize:"0.8rem",padding:"0"}:{}:{fontSize:"1.8rem"}} onClick={()=>{this.ShowLanguage(item,"button"+LangList.indexOf(item))}}>{item}</button>)
        }
        </div>
        <div className="LangComp">
        {this.renderComponent()}
        </div>
      </div>
    )
  }
}
  

  //页面根组件
  class EventPage extends React.Component{
    componentDidMount(){
      document.title = 'AnXiens'
  }
    render(){
      const offsetWidth = document.querySelector("body").offsetWidth
      return (
          <div className="MainPage" style={offsetWidth<1080?{backgroundSize:"cover"}:{backgroundSize:"contain"}}>
          <Title/>
          <EventContainer/>
          </div>
        )
      }
  }
  
    export default EventPage